import UUID from 'uuid'
import { merge2Obj, deepCopy } from '../../miscUtil'

/**
 * 新建dom
 * @param {String} html
 */
function newDom(html) {
    const dom = document.createElement('div')
    dom.innerHTML = html
    return dom.children[0]
}

/**
 * OdmsLayer
 */
export default class OdmsLayer {
    /**
     * odmsLayer
     * @param {{options:Array, layers:Array}} echartOption
     * @param {*} param1
     */
    constructor(
        echartOption,
        { name, visibility, opacity, maxExtent, minZoom, maxZoom }
    ) {
        // 复制用参数
        this._cloneOptions = deepCopy(arguments)
        // map对象
        this._map = null

        // 可见性相关
        this._visibility = visibility
        this._perVisibility = null

        this._minZoom = minZoom
        this._maxZoom = maxZoom

        this._zoomHandler = this._render.bind(this)

        // metadata
        this.metadata = {
            type: 'ODMS',
            maxExtent
        }

        this._echartOption = echartOption
        this._echartOption.layers = this._echartOption.layers.map(l => {
            delete l.source.data.customprj
            return merge2Obj(l, {
                id: 'ODMSLayerId_' + name + UUID.v1(),
                metadata: {
                    type: 'ODMS',
                    maxExtent
                },
                paint: {
                    'fill-opacity': opacity
                },
                layout: {
                    visibility: 'visible'
                }
            })
        })

        // 底图
        this._layers = this._echartOption.layers.map(l => l.id)

        // markers
        this._markers = []
    }

    /**
     * @private
     * 初始化markers
     */
    _initMarkers() {
        // echart marker
        const options = this._echartOption.options
        for (let i = 0; i < options.length; i++) {
            const option = options[i]
            const lonLat = [option.lonLat.lng, option.lonLat.lat]
            //构建图表div
            const div = `<div class='echart' style='width:${
                option.box.w
            }px; height:${option.box.h}px;'></div>`
            // marker
            const marker = new GeoGlobe.Marker(newDom(div))
            marker.setLngLat(lonLat).addTo(this._map)

            // init echart
            global.echarts.init(marker.getElement()).setOption(option.option)

            this._markers.push(marker)
        }
        // 注记marker
        const layers = this._echartOption.layers
        for (let i = 0; i < layers.length; i++) {
            const features = layers[i].source.data.features
            for (let j = 0; j < features.length; j++) {
                const box =
                    '<div class="label-marker" style="font-size:12px;font-weight:400;font-family:SimSun;color:#000;">' +
                    features[j].properties.name +
                    '</div>'

                const lonLat = new GeoGlobe.LngLat(
                    features[j].properties.centroidX,
                    features[j].properties.centroidY
                )
                const marker = new GeoGlobe.Marker(newDom(box))
                marker.setLngLat(lonLat).addTo(this._map)
                this._markers.push(marker)
            }
        }
    }

    get minzoom() {
        return this._minZoom
    }

    get maxzoom() {
        return this._maxZoom
    }

    /**
     * 设置缩放
     * @api
     * @param {*} minZoom
     * @param {*} maxZoom
     */
    setLayerZoomRange(minZoom, maxZoom) {
        minZoom && (this._minZoom = minZoom)
        maxZoom && (this._maxZoom = maxZoom)
        this._render()
    }

    /**
     * 设置可见性（需要map初始化完成）
     * @api
     * @param {Boolean} flag
     */
    setVisible(flag) {
        this._visibility = !!flag
        this._render()
    }

    /**
     * 添加到map或者从map中移除
     * @api
     * @param {*} map
     */
    setMap(map) {
        // 已经被初始化
        if (map && this._map) return

        // 未被初始化
        if (map) {
            this._map = map
            // 加载layers
            this._map.addLayers(this._echartOption.layers)
            // add markers
            if (this._markers.length) {
                this._markers.forEach(m => m.addTo(this._map))
            } else {
                this._initMarkers()
            }
            // render layer
            this._perVisibility = null
            this._render()

            // zoom event
            this._map.on('zoomend', this._zoomHandler)
        } else {
            if (!this._map) return

            // zoom event
            this._map.off('zoomend', this._zoomHandler)

            // clear layer
            this._layers.forEach(l => {
                this._map.removeSource(l)
                this._map.removeLayer(l)
            })
            // clear marker
            this._markers.forEach(m => m.remove())

            // reset map
            this._map = null
        }
    }

    /**
     * @api
     * 删除对象
     */
    destroy() {
        if (!this._map) return
        this._map.off('zoomend', this._zoomHandler)
        this._layers.forEach(l => {
            this._map.removeSource(l)
            this._map.removeLayer(l)
        })
        this._markers.forEach(m => m.remove())

        delete this._map
        delete this._echartOption
        delete this._layers
        delete this._markers
    }

    /**
     * @api
     * 获取对象克隆体
     */
    getClone() {
        return new OdmsLayer(this._cloneOptions[0], this._cloneOptions[1])
    }

    /**
     * @private
     * 更新渲染图层函数
     */
    _render() {
        if (this._map) {
            let _visibility = false
            // 通过zoomrange判断可见性
            if (this._visibility) {
                const zoom = this._map.getZoom()
                _visibility = zoom >= this._minZoom && zoom <= this._maxZoom
            }

            // 需要更新
            if (this._perVisibility !== _visibility) {
                // 更新可见性
                this._layers.forEach(l => {
                    this._map.setLayoutProperty(
                        l,
                        'visibility',
                        _visibility ? 'visible' : 'none'
                    )
                })
                // 更新marker元素可见性
                this._markers.forEach(m => {
                    m.getElement().style.visibility = _visibility
                        ? ''
                        : 'hidden'
                })
            }
            this._perVisibility = _visibility
        }
    }
}
